import React, { Component } from 'react'
import URLUtils from '../../util/URLUtils'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import SignUpWithEmailPageUI from './SignUpWithEmailPageUI.js'

class SignUpWithEmailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      captchaKey: null,
      messageList: null,
      socialLoginUrl: null,
      signUpWithPassword: false,
      showFBLogin: false
    }
  }

  render() {
    return (
      <SignUpWithEmailPageUI
        context={this.props.context}
        captchaKey={this.state.captchaKey}
        messageList={this.state.messageList}
        socialLoginUrl={this.state.socialLoginUrl}
        signUpWithPassword={this.state.signUpWithPassword}
        onSignUpWithPasswordClick={this.onSignUpWithPasswordClick}
        showFBLogin={this.state.showFBLogin}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCaptchaPublicKey(context)
    this.getSocialLoginUrl(context)
    this.getMessages(context)

    let params = new URLSearchParams(window.location.search)
    let showFBLogin = params.has('fb')
    this.setState({showFBLogin: showFBLogin})
  }

  onSignUpWithPasswordClick = (event) => {
    this.setState({signUpWithPassword: true})
  }

  getCaptchaPublicKey(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/reCaptcha/publicKey',
      cacheKey: CacheKeys.CaptchaKey,
      callback: this.getCaptchaPublicKeyCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, {})
  }

  getCaptchaPublicKeyCallback = (response) => {
    this.setState({captchaKey: response.publicKey})
  }

  getSocialLoginUrl(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/socialLoginUrl',
      cacheKey: CacheKeys.SocialLoginUrl,
      callback: this.getSocialLoginUrlCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, {baseUrl: URLUtils.getBaseURL()})
  }

  getSocialLoginUrlCallback = (response) => {
    this.setState({socialLoginUrl: response})
  }

  getMessages(context) {
    let arr = [
      'c_sign_up_w_email_pwd',
      'c_or',
      'c_login_with_fb',
      'c_login_with_g',
      'c_signup_agreeto_terms',
      'c_sign_up'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_signup_w_em', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default SignUpWithEmailPageSF
